export enum CardOrderingStatus {
  CARD_ORDER_CREATED = "CREATED",
  CARD_ORDER_SENT_TO_PRINT = "SENT_TO_PRINT",
  CARD_ORDER_PARTIALLY_PRINTED = "PARTIALLY_PRINTED",
  CARD_ORDER_PRINTED = "PRINTED"
}
